const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};

window.ON_CHANGE_DEBOUNCE_TIMER = ON_CHANGE_DEBOUNCE_TIMER;
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

/*
 * Quantity Break price fix: the bundle display divided the fixed bundle price by the
 * quantity and rounded per unit (e.g. 29.99 / 2 -> 15.00 x 2 = 30.00).
 * When a fixed custom bundle price exists for the requested quantity, pass the exact
 * bundle total with quantity 1 instead.
 */
(function () {
  function fixQuantityBreakPricing() {
    var orig = window.Elixir_GetDisplayPrice;
    if (typeof orig !== 'function') return false;
    if (orig.__qbFixed) return true;
    var wrapped = function (opts) {
      try {
        if (opts && opts.multiplyByQuantity && opts.quantity > 1) {
          var q = opts.quantity;
          var inp = document.querySelector('input.quantity-break-input[data-option-quantity="' + q + '"][data-enable-custom-pricing="true"][data-custom-price-format="amount"]');
          if (inp) {
            var amount = parseFloat(inp.getAttribute('data-custom-price-amount'));
            var compare = parseFloat(inp.getAttribute('data-custom-compare-at-price'));
            if (!isNaN(amount)) {
              return orig.call(this, Object.assign({}, opts, {
                price: Math.round(amount * 100),
                compareAtPrice: isNaN(compare) ? opts.compareAtPrice * q : Math.round(compare * 100),
                quantity: 1
              }));
            }
          }
        }
      } catch (e) {}
      return orig.apply(this, arguments);
    };
    wrapped.__qbFixed = true;
    window.Elixir_GetDisplayPrice = wrapped;
    return true;
  }
  if (!fixQuantityBreakPricing()) {
    document.addEventListener('DOMContentLoaded', fixQuantityBreakPricing);
  }
})();
